import {createContext} from "react";

export const emptyUserView = {
    userId: null,
    presetName: 'Default Preset',
    isActivePreset: true,
    _id: null,
    overviewViews: ['revenue', 'cost', 'profit', 'requests','incomingRequests','fillRate','adFillRate'],
    tableViews: ['fillRate', 'cpm', 'impressions', 'completion','incomingRequests','adFillRate'],
    cardViews: ['revenue', 'cost', 'profit', 'requests','incomingRequests','adFillRate','fillRate'],
    graphViews: ['netProfit', 'profit', 'netRevenue', 'revenue', 'netCost', 'cost', 'impressions', 'requests', 'completion','incomingRequests','fillRate','adFillRate']
}


export const UserViewsContext = createContext({
    userViews: {
        userViewsPresets: [emptyUserView],
        activePreset: emptyUserView
    },
    setUserViews: (userViews) => {}
})